export default "__VITE_ASSET__DERc7oiG__"